import React, {Component, useState, useEffect, useRef} from "react";
import * as com from "../Common.js";
import Form from "react-bootstrap/Form";
import {Col, Row, Select} from "antd";
import {InputGroup} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";
var parser = require("parse-address");

export default class AddressAutocomplete extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.state = {
      value: props.defaultValue,
    };
  }

  onValidate = (adr) => {
    if (!this.props.onCompletion) {
      this.ref.current.setCustomValidity("");
      let parsed = parser.parseLocation(adr);
      if (parsed != null) {
        let busted = false;
        if (parsed.number === undefined) {
          busted = true;
          this.ref.current.setCustomValidity("Need to specify house number");
        }
        if (parsed.zip === undefined) {
          busted = true;
          this.ref.current.setCustomValidity("Need to specify zip code");
        }
        if (!busted) this.ref.current.setCustomValidity("");
        console.log("parsed addr", JSON.stringify(parsed));
      }
    }
  };
  onChange = (e) => {
    e.preventDefault();
    let adr = e.target.value;
    this.onValidate(adr);

    this.props.onChange(e);
  };
  onBlur = (e) => {
    let adr = e.target.value;
    this.onValidate(adr);
    if (this.props.onBlur != null) {
      this.props.onBlur(e);
    }
  };
  componentDidMount() {
    if(!window.google?.maps?.places?.Autocomplete) return;
    this.autocomplete = new window.google.maps.places.Autocomplete(document.getElementById(this.props.id), {
      types: ["address"],
      componentRestrictions: {country: "us"},
    });

    this.autocomplete.addListener("place_changed", this.handlePlaceSelect);
    this.onValidate(this.props.defaultValue);
  }
  handlePlaceSelect = () => {
    let addressObject = this.autocomplete.getPlace();
    let address = addressObject.address_components;

    if ("undefined" === typeof address) return;

    let num = com.getSubaddress(address, "street_number", "long_name");
    let str = com.getSubaddress(address, "route", "long_name");

    if (this.props.onCompletion) {
      let straddr = `${num} ${str}`;
      this.ref.current.value = straddr;
      this.onValidate(address);
      //this.props.onChange({target: {value: straddr}})
      this.props.onCompletion(address);
    } else {
      let city = com.getSubaddress(address, "locality", "long_name");
      let state = com.getSubaddress(address, "administrative_area_level_1", "short_name");
      let zip = com.getSubaddress(address, "postal_code", "long_name");
      let zips = com.getSubaddress(address, "postal_code_suffix", "short_name");
      //let country = com.getSubaddress(address, "country", "long_name")

      if (zips !== "") zip = zip + "-" + zips;

      let straddr = `${num} ${str}, ${city}, ${state} ${zip}`;
      this.onValidate(straddr);
      this.props.onChange({target: {value: straddr}});
    }
  };
  render = () => {
    return (
      <Form.Group
        controlId={this.props.id}
        className="text-left input-groups">
        {this.props.label !== null && this.props.label !== "" ? (
          <Form.Label className="text-left">{this.props.label}</Form.Label>
        ) : (
          ""
        )}
        <Form.Control
          isValid={false}
          size={this.props.size}
          ref={this.ref}
          required={this.props.required}
          name={this.props.name}
          onBlur={this.onBlur}
          autoComplete={this.props.autocomplete}
          type={this.props.type}
          value={this.props.defaultValue}
          onChange={this.onChange}
          pattern={this.props.pattern}
          placeholder={this.props.placeholder}
          style={this.props.style}
        />
        <Form.Control.Feedback>{this.props.goodfeedback}</Form.Control.Feedback>
        <Form.Control.Feedback type="invalid">{this.props.badfeedback}</Form.Control.Feedback>
      </Form.Group>
    );
  };
}

// fullAddressLine: opt-in; Places completion writes LOS-style
// "123 Main St, City, ST 12345" into the street field. Default remains street-only.
export const AddressComponent = ({id, label, address, unit, state, county, city, zip, onAddressLineChange, onUnitChange, onStateChange, onCountyChange, onCityChange, onZipChange, placeholder, cityPlaceholder, zipPlaceholder, required = false, pattern, validateZip = false, fullAddressLine = false}) => {
  const [loanLimits, setLoanLimits] = useState([]);
  const zipInputRef = useRef(null);
  const [addressLine, setAddressLine] = useState(address);
  const [addressUnit, setAddressUnit] = useState(unit || "");
  const [addressState, setAddressState] = useState(state);
  const [addressCounty, setAddressCounty] = useState(county);
  const [addressCity, setAddressCity] = useState(city);
  const [addressZip, setAddressZip] = useState(zip);

  useEffect(() => {
    fetchLoanLimits();
  }, []);

  useEffect(() => {
    setAddressLine(address || "");
    setAddressUnit(unit || "");
    setAddressState(state || "");
    setAddressCounty(county || "");
    setAddressCity(city || "");
    setAddressZip(zip || "");
  }, [address, unit, state, county, city, zip]);

  // Preserve the legacy Employment behavior: an empty address may remain a
  // draft, but once an address has been entered a missing ZIP is invalid.
  // This is intentionally separate from `required`, which also controls the
  // street and city inputs for callers that require a complete address.
  useEffect(() => {
    if (!zipInputRef.current) return;
    const hasAddress = [addressLine, addressUnit, addressState, addressCounty, addressCity]
      .some((value) => String(value || "").trim() !== "");
    zipInputRef.current.setCustomValidity(
      validateZip && hasAddress && !String(addressZip || "").trim()
        ? "Need to specify zip code"
        : ""
    );
  }, [validateZip, addressLine, addressUnit, addressState, addressCounty, addressCity, addressZip]);

  const fetchLoanLimits = () => {
    fetch("/data/loanlimits")
      .then((res) => {
        if (!res.ok) {
          throw Error(res.statusText);
        }
        return res.json();
      })
      .then((res) => {
        setLoanLimits(res);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getStates = () => {
    let options = [];
    let keys = Object.keys(loanLimits);

    keys.forEach((x) => {
      options.push(<option key={x} value={com.capitalize(x)}>{com.capitalize(x)}</option>);
    });
    return options;
  };

  const getCounties = () => {
    let options = [];

    try {
      if (loanLimits[addressState.toUpperCase()]) {
        let keys = Object.keys(loanLimits[addressState.toUpperCase()]);
        keys.forEach((x) => {
          options.push(<option key={x} value={com.capitalize(x)}>{com.capitalize(x)}</option>);
        });
      }
    } catch (error) {
      console.log(error);
    }
    return options;
  };

  const onStreetAddressCompletion = (address) => {
    let num = com.getSubaddress(address, "street_number", "long_name");
    let city = com.getSubaddress(address, "locality", "long_name");
    let state = com.getSubaddress(address, "administrative_area_level_1", "short_name");
    let zip = com.getSubaddress(address, "postal_code", "long_name");
    let county = com.getSubaddress(address, "administrative_area_level_2", "long_name");

    let longstate = com.getSubaddress(address, "administrative_area_level_1", "long_name");
    let short = com.getSubaddress(address, "route", "short_name");
    const street = `${num} ${short}`.trim();
    const cityLine = [city, [state, zip].filter(Boolean).join(" ")].filter(Boolean).join(", ");
    // Match LOS Interview1003ViewV2More.fullAddressFromPlace when fullAddressLine is set.
    let stradd = fullAddressLine
      ? [street, cityLine].filter(Boolean).join(", ")
      : street;

    setAddressLine(stradd);
    setAddressState(longstate);
    setAddressCounty(county);
    setAddressCity(city);
    setAddressZip(zip);

    onAddressLineChange(stradd);
    onStateChange(longstate);
    onCountyChange(county);
    onCityChange(city);
    onZipChange(zip);
  };

  return (
    <div>
      <Row>
        <Col span={24}>
          <AddressAutocomplete
            id={id}
            label={label}

            name="addressline"
            defaultValue={addressLine}
            onChange={(e) => {
              setAddressLine(e.target.value);
              onAddressLineChange(e.target.value);
            }}
            placeholder={placeholder ? placeholder : "Enter the address"}
            pattern={pattern}
            required={required}
            goodfeedback=""
            badfeedback="Please provide your street address."
            onCompletion={(e) => onStreetAddressCompletion(e)}
            size="md"
          />
        </Col>
      </Row>
      <Row justify="space-between" className="mt-3"  gutter={16}>
        <Col span={24}>
          <Form.Control
            value={addressUnit}
            onChange={(e) => {
              setAddressUnit(e.target.value);
              if (onUnitChange) onUnitChange(e.target.value);
            }}
            placeholder="Apt, suite, building, etc. (Optional)"
          />
        </Col>
      </Row>
      <Row justify="space-between" className="mt-3"  gutter={16}>
        <Col span={6}>
            <Select
              className="w-100"
              placeholder="State"
              value={addressState || "State"}
              onChange={(e) => {
                setAddressState(e);
                onStateChange(e);
              }}>
              {getStates()}
            </Select>
        </Col>
        <Col span={6}>
            <Select
                className="w-100"
                placeholder="County"
              onChange={(e) => {
                setAddressCounty(e);
                onCountyChange(e);
              }}
              value={addressCounty || "County"}>
              {getCounties()}
            </Select>
        </Col>
        <Col span={6}>
          <Form.Group>
            <Form.Control
              required={required}
              onChange={(e) => {
                setAddressCity(e.target.value);
                onCityChange(e.target.value);
              }}
              value={addressCity}
              placeholder={cityPlaceholder ? cityPlaceholder : "City"}
            />
          </Form.Group>
        </Col>
        <Col span={6}>
          <Form.Group>
            <Form.Control
              ref={zipInputRef}
              required={required}
              onChange={(e) => {
                setAddressZip(e.target.value);
                onZipChange(e.target.value);
              }}
              value={addressZip}
              placeholder={zipPlaceholder ? zipPlaceholder : "Zip code"}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};
